import { Question } from "survey-core";

import questionTypes from "view/pages/Forms/EditFormDetails/Components/SurveyJs/questionTypes";

export default class QuestionGetGpsDataModel extends Question {
  getType() {
    return questionTypes.getGpsData;
  }
}
